import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CoreModule} from '../../core/core.module';
import { TranslationsModule } from '../../core/translations/translations.module';
import { FranchiseComponent } from './franchise.component';
import { TranslationsService} from '../../core/translations/translations.service';
import { transcode } from 'buffer';


const routes: Routes = [
  {
    path: '',
    component: FranchiseComponent,
    data: {
      title:  'רשתות' //{{'TOPNAV.INCOMEORDERS' | translate}}//
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    TranslationsModule,
    CoreModule],
  exports: [RouterModule],
  providers: [
    TranslationsService//,
   //IncomingOrderService,
   // AppStorageService
  ],
})
export class  FranchiseRoutingModule {}
